export default function mensagemReducer(state = {tipo: '', texto: ''}, action) {
    if( action.type === 'SHOW_MESSAGE' ) {
        return action.mensagem;
    }
    if( action.type === 'DELETE_MESSAGE' ) {
        return {tipo: '', texto: ''};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/mensagemReducer.js